export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create.vue?vue&type=template&id=42f7ab5d&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/create.vue?vue&type=template&id=42f7ab5d&scoped=true
// module id = J0lc
// module chunks = 0